import React from 'react';
import { Page, Text, BlockStack } from "@shopify/polaris";

import Link from "../../components/Link";
import styles from "./NotFound.module.css";

function NotFound() {
  return (
    <Page>
      <div className={styles.container}>
        <div className={styles.item}>
          <BlockStack gap="200">
            <Text variant="heading3xl" as="p">
              404
            </Text>
            <Text variant="heading2xl" as="p">
              Not Found
            </Text>
            <p>The page you were looking for doesn't exist.</p>
            <br />
            <Link url="/">Home</Link>
          </BlockStack>
        </div>
      </div>
    </Page>
  );
};


export default NotFound;
